// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"06ad6595","455":"bf913a9d","726":"63e59fed","977":"c9073930"}[chunkId] + ".chunk.js";
};